import React, { useState, useEffect } from 'react';
import { Typography, Box } from '@mui/material';
import { adminApi } from '../../services/api';

// eslint-disable-next-line no-unused-vars
const CodeOwnerWidget = () => {
    const [codeOwners, setCodeOwners] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchCodeOwners = async () => {
            try {
                const response = await adminApi.getCodeOwners();
                setCodeOwners(response.data);
            } catch (error) {
                console.error('Error fetching code owners:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchCodeOwners();
    }, []);

    if (loading) {
        return <Typography>Loading...</Typography>;
    }

    return (
        <Box sx={{ 
            width: '100%',
            maxWidth: '100%',
            overflowX: 'hidden',
            boxSizing: 'border-box'
        }}>
            <Typography variant="h6" gutterBottom>
                Code Owners Activity
            </Typography>
            {/* Add code owner activity visualization here */}
            <Typography variant="body2" color="text.secondary">
                Code owner engagement metrics will be displayed here
            </Typography>
        </Box>
    );
};

export default CodeOwnerWidget; 